import { TFSEntryMetadata, TFSSearchResult, type Id, type TFSSearchRequest } from "@/models"
import { ApiService } from "@/services"

export class TfsMetadataService extends ApiService {
	constructor() {
		super("/api/tfs-metadata")
	}

	async get(id: Id) {
		return await this.returning(TFSEntryMetadata).get(String(id))
	}

	async search(request: TFSSearchRequest) {
		return await this.returning(TFSSearchResult).post("search", request)
	}
}
